import React, { useEffect, useState } from 'react';
import TextSubHeader from 'components/CustomText/TextSubHeader';
import styled from 'styled-components';

// const useStyles = makeStyles((theme) => ({
//     root: {
//         marginTop: theme.spacing(4),
//     },
//     container: {
//         border: '1px solid #ddd',
//         paddingLeft: theme.spacing(2),
//         paddingRight: theme.spacing(2),
//         marginTop: theme.spacing(2),
//     },
//     title: {
//         marginRight: theme.spacing(4),
//         fontWeight: 'bold',
//     },
//     item: {
//         paddingTop: theme.spacing(1),
//         paddingBottom: theme.spacing(1),
//     },
//     content: {
//         paddingTop: theme.spacing(1),
//         paddingBottom: theme.spacing(1),
//         paddingRight: theme.spacing(8),
//     },
//     diver: {
//         width: '100%',
//     },
//     number: {
//         width: '50px',
//         height: '30px',
//     },
// }));

const SContainer = styled.div`
    border-radius: 5px;
    border: 1px solid #dcdcdc;
    margin-top: 10px;
`;

const SRow = styled.div`
    display: flex;
    padding: 8px;
    justify-content: space-between;
`;

const SItem = styled.div`
    display: flex;
    width: 30%;
    justify-content: space-between;
    align-items: center;
`;

const SCount = styled.div`
    border-radius: 15px;
    background: #3f51b5;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    width: 50px;
    padding: 5px 0px;
`;

const SDivider = styled.div`
    height: 1px;
    background: #dcdcdc;
    width: 100%;
`;

const PanelMemberComposition = ({ memberComposition = [] }) => {
    // const classes = useStyles();
    const [list, setList] = useState({
        member: 0,
        female: 0,
        male: 0,
        scientificMember: 0,
        nonScientificMember: 0,
        independentMember: 0,
    });

    useEffect(() => {
        let data = {
            member: memberComposition.length,
            female: 0,
            male: 0,
            scientificMember: 0,
            nonScientificMember: 0,
            independentMember: 0,
        };
        memberComposition.forEach((element) => {
            // data.female=element.gender==='F'?++data.female
            if (element.gender === 'F' || element.gender === 'Female') data.female += 1;
            if (element.gender === 'M') data.male += 1;
            if (element.background === 'Scientific') data.scientificMember += 1;
            if (element.background === 'Non-Scientific') data.nonScientificMember += 1;
            if (element.independent?.toString() === '1') data.independentMember += 1;
        });
        setList(data);
    }, [memberComposition]);

    return (
        <div>
            <TextSubHeader>Panel Member Composition</TextSubHeader>

            <SContainer>
                <SRow>
                    <SItem>
                        <TextSubHeader>Members:</TextSubHeader>
                        <SCount>{list.member}</SCount>
                    </SItem>
                </SRow>
                <SDivider />

                <SRow>
                    <SItem>
                        <TextSubHeader>Female:</TextSubHeader>
                        <SCount> {list.female}</SCount>
                    </SItem>
                    <SItem>
                        <TextSubHeader>Male:</TextSubHeader>
                        <SCount> {list.male}</SCount>
                    </SItem>
                    <SItem></SItem>
                </SRow>
                <SDivider />
                <SRow>
                    <SItem>
                        <TextSubHeader>Scientific Member:</TextSubHeader>
                        <SCount> {list.scientificMember}</SCount>
                    </SItem>
                    <SItem>
                        <TextSubHeader>Non-Scientific Member:</TextSubHeader>
                        <SCount> {list.nonScientificMember}</SCount>
                    </SItem>
                    <SItem>
                        <TextSubHeader>Independent Member:</TextSubHeader>
                        <SCount> {list.independentMember}</SCount>
                    </SItem>
                </SRow>
            </SContainer>
        </div>
    );
};

export default PanelMemberComposition;
